import { RESTError } from "../core/RESTError";

/**
 * An error that occurs while a user logged in several times.
 */
export class MaxLoginFailError extends RESTError {}
